import { helper } from '@ember/component/helper';

import { get } from 'rise-ui/utils/object.js';

export default helper(function metaEveryHelper([ metaArr, key ]) {
  return metaArr.every(m => get(m, key));
});
